function createMyAccountEditInfoSelects(){
    createSelect2Single('.js-edit-race-team-field-wrapper', raceTeamData, 'Not specified');
    createSelect2Single('.js-edit-home-mountain-field-wrapper', homeMountainData, 'Not specified');
}

runIfElementExist(createMyAccountEditInfoSelects, '.js-edit-race-team-field-wrapper');

function createClaimDayMountainSelect(){
    createSelect2Single('.js-claim-day-field-wrapper', mountainData, 'Select mountain');
};

runIfElementExist(createClaimDayMountainSelect, '.js-claim-day-field-wrapper');

function createLeaguePssMountainSelect(){
    createSelect2Single('.js-league-pass-choose-mountain-field-wrapper', mountainData, 'Select mountain');
};

runIfElementExist(createLeaguePssMountainSelect, '.js-league-pass-choose-mountain-field-wrapper');
